"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";
import FormErrorMessage from "./webflow_modules/Form/components/FormErrorMessage";
import FormForm from "./webflow_modules/Form/components/FormForm";
import FormSuccessMessage from "./webflow_modules/Form/components/FormSuccessMessage";
import FormTextInput from "./webflow_modules/Form/components/FormTextInput";
import FormWrapper from "./webflow_modules/Form/components/FormWrapper";
import { SearchInputClearButton } from "./SearchInputClearButton";
import { SearchInputSearchButton } from "./SearchInputSearchButton";
import { SearchModalResultItem } from "./SearchModalResultItem";

export function SearchModal({ showPopover = true }) {
  return (
    <Block className={"frame-151"} tag={"div"}>
      <Block className={"frame-136"} tag={"div"}>
        <Block className={"search-large-component"} tag={"div"}>
          <FormWrapper className={"form-block-copy"}>
            <FormForm
              className={"form"}
              data-name={"Email Form 2"}
              id={"email-form-2"}
              method={"get"}
              name={"email-form-2"}
            >
              <Block className={"seach-frame-container-large"} tag={"div"}>
                <FormTextInput
                  autoFocus={false}
                  className={"text-field-large"}
                  data-name={"Search Input 2"}
                  disabled={false}
                  id={"search-input-2"}
                  maxLength={256}
                  name={"search-input-2"}
                  placeholder={"Search by Location or Community Name"}
                  required={true}
                  type={"text"}
                />
                <SearchInputSearchButton />
                <SearchInputClearButton showClearButton={true} />
              </Block>
            </FormForm>
            <FormSuccessMessage />
            <FormErrorMessage />
          </FormWrapper>
        </Block>
      </Block>
      {showPopover ? (
        <Block className={"search-results-large"} tag={"div"}>
          <Block className={"search-results-container"} tag={"div"}>
            <Block className={"frame-148"} tag={"div"}>
              <Block className={"text-46"} tag={"div"}>
                {"OUR LOCATIONS"}
              </Block>
              <Block className={"search---divider"} tag={"div"} />
            </Block>
            <Block className={"frame-147"} tag={"div"}>
              <SearchModalResultItem />
              <SearchModalResultItem />
              <SearchModalResultItem />
              <SearchModalResultItem />
            </Block>
            <Block className={" frame-148"} tag={"div"}>
              <Block className={" text-46"} tag={"div"}>
                {"OUR HOMES"}
              </Block>
              <Block className={"search---divider"} tag={"div"} />
            </Block>
            <Block className={"frame-212"} tag={"div"}>
              <SearchModalResultItem text={"apartment name"} />
              <SearchModalResultItem text={"apartment name"} />
            </Block>
          </Block>
        </Block>
      ) : null}
    </Block>
  );
}
